import { render } from "./iconItem.vue?vue&type=template&id=35a06d85&scoped=true"
import script from "./iconItem.vue?vue&type=script&lang=js"
export * from "./iconItem.vue?vue&type=script&lang=js"

import "./iconItem.vue?vue&type=style&index=0&id=35a06d85&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a06d85"]])

export default __exports__